import { getToken } from '../../Utils/authUtils';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { toSavedNormalRange } from '../../Utils/savedNormalRange';

interface MeasurementItem {
  measurementId: string;
  parameterName: string;
  category: '2D' | 'MMODE' | 'DOPPLER' | 'STRAIN' | 'DERIVED';
  value?: number | null;
  unit?: string;
  method?: string;
  planeView?: string;
  source: 'CALIPER' | 'TYPED' | 'SR_IMPORT' | 'DERIVED';
  derivedFrom?: {
    sopInstanceUID?: string;
    seriesInstanceUID?: string;
    frameIndex?: number;
  };
  annotationUID?: string;
  annotationData?: unknown;
  loincCode?: string;
  normalRange?: { low?: number; high?: number; indexed?: boolean };
  isAbnormal?: boolean;
  enteredBy?: string;
  enteredByName?: string;
  enteredAt?: string;
  overridden?: boolean;
  /** Worksheet metadata can be persisted while deliberately excluded from the PDF/GP view. */
  includeInReport?: boolean;
}

interface Payload {
  reportId?: string;
  studyInstanceUID: string;
  patientId?: string;
  status?: 'Draft' | 'Preliminary' | 'Finalized';
  measurements: MeasurementItem[];
}

// Upsert the full structured measurement set for a (report, study).
// Rides its own endpoint — does not touch the report save path.
export const saveStructuredMeasurements = createAsyncThunk(
  'saveStructuredMeasurements',
  async (payload: Payload, { rejectWithValue }) => {
    try {
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getToken(),
        },
        // Every screen saves through here; send ranges in the shape the API accepts.
        body: JSON.stringify({
          ...payload,
          measurements: payload.measurements.map(m => ({
            ...m,
            normalRange: toSavedNormalRange(m.normalRange),
          })),
        }),
      };
      const res = await fetch(REPORTS.SAVE_STRUCTURED_MEASUREMENTS, requestOptions);

      if (!res.ok) {
        const errorData = await res.json();
        return rejectWithValue(errorData.message || 'Save measurements failed');
      }

      const data = await res.json();
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
